<template>
    <div class="footer-wrapper">
        <div class="footer">
			<p>CopyRight (©) 2018-2022 敦煌文旅 All Rights Reserved</p>
		
			<p>
				<a target="_blank" rel="noopener noreferrer" href="http://beian.miit.gov.cn/">陇ICP备2020004242号-1</a>&nbsp;&nbsp;
				<a target="_blank" rel="noopener noreferrer" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62098202000341" >甘公网安备 62098202000341号</a>
			</p>
		</div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: {},
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
</script>

<style scoped lang="scss">
.footer-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    width: 100%;
    color: rgba(117, 117, 117, 0.85);
    height: 68px;
    background: #ebebeb;

    .footer {
        max-width: 1200px;
        margin: 0 auto;
        text-align: center;
		p{
			font-size:12px;
			display: block;
			line-height: 20px;
			a{
				color:rgba(117, 117, 117, 0.85);
				text-decoration: none;
				margin:5px;
			}
		}
    }
}
</style>
